<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <div class="d-flex flex-row flex-wrap justify-content-between mb-4">
            <div>
              <h1 class="card-title mb-1">Dealers</h1>
              <span class="sub-text">Manage and track all dealers information</span>
            </div>

            <div class="d-flex align-items-center gap-2">
              <button
                class="btn btn-soft-primary d-flex align-items-center gap-2"
                (click)="onExportDealerList()"
                [disabled]="isExportingDealerList">
                @if (isExportingDealerList) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Exporting...
                } @else {
                  <i class="bi bi-download"></i>
                  Export Dealers List
                }
              </button>
              <button class="btn btn-primary btn-enjochem" (click)="onAddNewDealer()">
                <i class="bi bi-plus-circle"></i>
                <span>Add New Dealer</span>
              </button>
            </div>
          </div>

          <!-- Modern Filter Bar -->
          <div class="row g-3 mb-4">
            <div class="col-md-6 ps-0">
              <div class="input-group">
                <span class="input-group-text bg-white border-end-0 ps-3 rounded-0">
                  <i class="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  class="form-control ps-2 rounded-0 border-start-0"
                  placeholder="Search by dealer name, shop name, or ID..."
                  [(ngModel)]="searchTerm"
                  (keyup)="onSearchKeyUp()" />
              </div>
            </div>

            <div class="col-md-3">
              <ng-select
                placeholder="All Sales Officers"
                [items]="salesOfficers"
                [(ngModel)]="selectedSalesOfficerId"
                (ngModelChange)="onListFilterChange()"
                bindValue="id"
                bindLabel="full_name"
                [clearable]="true"
                [searchable]="true" />
            </div>

            <div class="col-md-3 pe-0">
              <ng-select
                placeholder="All Designations"
                [items]="designations"
                [(ngModel)]="selectedDesignationId"
                (ngModelChange)="onListFilterChange()"
                bindValue="id"
                bindLabel="title"
                [clearable]="true"
                [searchable]="true" />
            </div>
          </div>

          @if (isDealersDataLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <div class="table-responsive custom-table-container">
              <!-- Show this when there are no dealeers -->
              <div *ngIf="(dealersList || []).length === 0" class="empty-state-container">
                <i class="bi bi-shop"></i>
                <h5>No Dealers Found</h5>
                <p>
                  You can add dealers by clicking the
                  <strong>+ Add New Dealer</strong>
                  button.
                </p>
              </div>

              <!-- Show the table when dealers exist -->
              <table class="table align-middle" *ngIf="(dealersList || []).length > 0">
                <thead class="text-muted">
                  <tr>
                    <th>
                      <button
                        type="button"
                        class="btn btn-link p-0 border-0 text-muted text-decoration-none d-inline-flex align-items-center gap-1"
                        (click)="onToggleDealerNumberSort()"
                        [title]="sortDirection === 'asc' ? 'Sorted low to high' : 'Sorted high to low'">
                        ID
                        <i
                          class="bi"
                          [ngClass]="sortDirection === 'asc' ? 'bi-sort-numeric-down' : 'bi-sort-numeric-up-alt'"></i>
                      </button>
                    </th>
                    <th>Shop Name</th>
                    <th>Owner Name</th>
                    <th>Contact Number</th>
                    <th>Firm Type</th>
                    <th>Sales Officer</th>
                    <th>Area Sales Manager</th>
                    <th>Regional Sales Manager</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dealer of dealersList" (click)="viewDealerDetails(dealer.id)" class="clickable-row">
                    <td>{{ dealer.dealer_number }}</td>
                    <td>{{ dealer.shop_name }}</td>
                    <td>{{ dealer.first_name + ' ' + dealer.last_name }}</td>
                    <td>{{ dealer.phone_number }}</td>
                    <td>{{ FirmTypeLabel[dealer.firm_type] || '-' }}</td>
                    <td>
                      @if (dealer.sales_officer) {
                        <span>{{ dealer.sales_officer.full_name }}</span>
                      } @else {
                        <span class="app-badge badge-danger">Not assigned</span>
                      }
                    </td>
                    <td>
                      @if (dealer.area_sales_manager) {
                        <span>{{ dealer.area_sales_manager.full_name }}</span>
                      } @else {
                        <span class="app-badge badge-danger">Not assigned</span>
                      }
                    </td>
                    <td>
                      @if (dealer.regional_sales_manager) {
                        <span>{{ dealer.regional_sales_manager.full_name }}</span>
                      } @else {
                        <span class="app-badge badge-danger">Not assigned</span>
                      }
                    </td>
                    <td class="text-center">
                      <div class="d-flex flex-row gap-2 justify-content-center">
                        <button
                          class="btn btn-action-edit"
                          (click)="$event.stopPropagation(); editDealer(dealer)"
                          title="Edit">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button
                          class="btn btn-action-delete"
                          (click)="$event.stopPropagation(); onClickDeleteDealer(dealer.id)"
                          title="Delete">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <app-pagination
                *ngIf="(dealersList || []).length > 0"
                [currentPage]="currentPage"
                [totalCount]="totalCount"
                [pageSize]="10"
                [hasNextPage]="hasNextPage"
                [hasPreviousPage]="hasPreviousPage"
                (pageChange)="onPageChange($event)"></app-pagination>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #exportDealersModal let-modal>
  <div class="modal-content border-0 shadow-lg">
    <div class="modal-header border-bottom-0 pb-0">
      <div>
        <h5 class="modal-title fw-bold">Export Dealers List</h5>
        <p class="sub-text small mb-0">Apply filters before exporting</p>
      </div>
      <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>

    <div class="modal-body pt-3">
      <!-- Employee -->
      <div class="mb-3">
        <label class="form-label small fw-semibold text-muted">Sales Employee</label>
        <ng-select
          placeholder="All Employees"
          [items]="salesEmployees"
          [(ngModel)]="exportFilters.employee"
          bindValue="id"
          bindLabel="full_name"
          [clearable]="true"
          [searchable]="true" />
      </div>

      <!-- Area / District -->
      <div class="mb-3">
        <label class="form-label small fw-semibold text-muted">District</label>
        <ng-select
          placeholder="All Districts"
          [items]="dealerAreas"
          [(ngModel)]="exportFilters.area"
          [clearable]="true"
          [searchable]="true" />
      </div>

      <!-- Firm Type -->
      <div class="mb-3">
        <label class="form-label small fw-semibold text-muted">Firm Type</label>
        <ng-select
          placeholder="All Firm Types"
          [items]="FirmTypeEntries"
          [(ngModel)]="exportFilters.firm_type"
          bindValue="0"
          bindLabel="1"
          [clearable]="true"
          [searchable]="false" />
      </div>
    </div>

    <div class="modal-footer border-top-0 pt-0">
      <button class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
      <button
        class="btn btn-primary btn-enjochem d-flex align-items-center gap-2"
        (click)="onConfirmExport(modal)"
        [disabled]="isExportingDealerList">
        @if (isExportingDealerList) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Exporting...
        } @else {
          <i class="bi bi-download"></i>
          Export
        }
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addNewDealerContent>
  <div class="modal-content border-0 shadow-lg">
    <div class="modal-header">
      <div>
        <h5 class="modal-title">
          {{ dealerToBeEdit ? 'Update Dealer Details' : 'Add New Dealer' }}
        </h5>
        <div class="sub-text small">Please fill in all the required fields to save the dealer's information.</div>
      </div>
      <button type="button" class="btn-close" (click)="modalRef?.close()" aria-label="Close"></button>
    </div>

    <app-dealers-info-form
      [dealer]="dealerToBeEdit"
      [mode]="dealerToBeEdit ? Action.EDIT : Action.CREATE"
      (onCancelEvent)="modalRef?.close()"
      (onSaveEvent)="onSaveDealersInfo($event)" />
  </div>
</ng-template>
